<template>
    <form-field v-bind="fieldProps">
        <select-input
            v-bind="inputProps"
            :groupOptions="groupOptions"
            :expandOptionsLeft="expandOptionsLeft"
            :expandOptionsRight="expandOptionsRight"
            :isSearchable="isSearchable"
            :icon="icon"
            @change="change($event)"
            @emitEvent="emitEvent($event, ['change'])"
        ></select-input>

        <template #hint>
            <slot name="hint"></slot>
        </template>

        <template #right>
            <slot name="right"></slot>
        </template>

        <template #error="{ error }">
            <slot name="error" :error="error"></slot>
        </template>
    </form-field>
</template>

<script>
    import FormFieldMixin from 'mixins/FormFieldMixin'
    import FormPrefillingMixin from 'mixins/FormPrefillingMixin'

    export default {
        mixins: [FormFieldMixin, FormPrefillingMixin],

        props: {
            placeholder: { type: String, default: undefined },
            options: { type: Array, required: true },
            isNullable: { type: Boolean, default: false },
            groupOptions: { type: Boolean, default: false },
            expandOptionsLeft: { type: Boolean, default: false },
            expandOptionsRight: { type: Boolean, default: false },
            isSearchable: { type: Boolean, default: false },
            icon: { type: String, default: undefined },
            isSuggested: { type: Boolean, default: false },
        },
    }
</script>
